<template>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
          <v-card-title class="primary white--text title">
              Points
          </v-card-title>
          <v-card-text>
              <v-text-field label="Sensor Name" autofocus v-model="activeItem.sensor_name"></v-text-field>
              <v-text-field label="Sensor Name Abbr" autofocus v-model="activeItem.sensor_name_abbr"></v-text-field>
              <v-text-field label="Unit" autofocus v-model="activeItem.unit"></v-text-field>
              <v-switch v-model="activeItem.faulty" label="Faulty" ></v-switch>
              <v-text-field label="Haystack ID" autofocus v-model="activeItem.haystack_id"></v-text-field>
              <v-text-field label="Weight" type="number" autofocus v-model.number="activeItem.weight"></v-text-field>
              <v-text-field label="Facility Name" autofocus v-model="activeItem.facility_name" disabled></v-text-field>
              <equipment-selector v-model="activeItem.equipment_name"></equipment-selector>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="addRecord(true)" :disabled="!$can('update', 'Points')">Save</v-btn>
              <v-btn @click="initializeVar(true)">Cancel</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import EquipmentSelector from '../EquipmentSelector'
  import {putPoint} from '../../helper'

  export default {
    components: { EquipmentSelector },
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
        }
      },
      value () {
        if (!this.activeItem.sensor_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
          //this.initializeVar()
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
        dialog: false,
        activeItem: {
          sensor_id: null,
          sensor_name: '',
          sensor_name_abbr: '',
          unit:  '',
            faulty:false,
            weight:1,
          haystack_id: '',
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
          equipment_name: '',
          meta: '',

        } ,

      }
    },
    methods: {
      initializeVar(close) {
        this.activeItem = {
          sensor_id: null,
          sensor_name: '',
          sensor_name_abbr: '',
          unit:  '',
          haystack_id: '',
            faulty:false,
            weight:1,
          equipment_name: '',
          meta: '',
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,


          }
          if(close) {
              this.dialog = false;
          }
      },
      addRecord (close) {
        putPoint(
          {
            'sensor_id': this.activeItem.sensor_id,
            'sensor_name': this.activeItem.sensor_name,
            'sensor_name_abbr': this.activeItem.sensor_name_abbr,
            'unit': this.activeItem.unit,
            'faulty': this.activeItem.faulty,
            'weight': this.activeItem.weight,
            'haystack_id': this.activeItem.haystack_id,
            'facility_name': this.activeItem.facility_name,
            'equipment_name': this.activeItem.equipment_name,
            'meta': this.activeItem.meta,

          }
        )
          this.$emit('reloadpoints', this.dialog)
          if(close) {
              this.dialog = false;
          }
      }
    },
    name: 'PointRecordDialog'
  }
</script>

<style scoped>

</style>
